var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container"},[(_vm.isOpen)?_c('div',{ref:"content",staticClass:"menu",style:({ top: _vm.top, right: _vm.right, left: _vm.left, maxHeight: _vm.maxHeight }),on:{"mousedown":_vm.clickmenu}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }